import React from 'react';
import PropTypes from 'prop-types';

export const TblRow = ({ children }) => {
  return <li>{children}</li>;
};
TblRow.propTypes = { children: PropTypes.node };
TblRow.defaultProps = { children: <></> };
export default TblRow;
